var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoadingIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.92781 15H12.0722V12.75C12.0722 11.8961 11.7736 11.1658 11.1765 10.5591C10.5794 9.95231 9.85388 9.64894 9 9.64894C8.14613 9.64894 7.42063 9.95231 6.8235 10.5591C6.22638 11.1658 5.92781 11.8961 5.92781 12.75V15ZM3.375 16.125V15H4.803V12.75C4.803 11.9058 5.034 11.1373 5.496 10.4445C5.958 9.75163 6.57025 9.27013 7.33275 9C6.57025 8.725 5.958 8.24231 5.496 7.55194C5.034 6.86156 4.803 6.09425 4.803 5.25V3H3.375V1.875H14.625V3H13.197V5.25C13.197 6.09425 12.966 6.86156 12.504 7.55194C12.042 8.24231 11.4298 8.725 10.6673 9C11.4298 9.27013 12.042 9.75163 12.504 10.4445C12.966 11.1373 13.197 11.9058 13.197 12.75V15H14.625V16.125H3.375Z",
    fill: "#8790A1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingIcon);
export default __webpack_public_path__ + "static/media/loading_icon.1f93e979742ecbe32a0d2184e927a99a.svg";
export { ForwardRef as ReactComponent };